<template>
  <v-row class="mx-0 px-5 py-12" :class="[bgcolor]">
    <v-col
      cols="12"
      sm="12"
      md="12"
      lg="8"
      offset-lg="2"
      xl="8"
      offset-xl="2"
      class="py-12 justify-center align-center d-flex flex-column"
    >
      <h2  class="text-center font-weight-regular justify--text" :class="[descriptionClass]" v-html="title"></h2>
      <br>
      <h2  class="text-center font-weight-regular justify--text" :class="[descriptionClass]" v-html="description"></h2>
    </v-col>
  </v-row>
</template>
<style scoped>
</style>
<script>
export default {
  props: ["title", "description", "bgcolor", "titleClass", "descriptionClass"]
};
</script>
